// extracted by mini-css-extract-plugin
export var form = "_5q-0";